import {
    AirlineConfiguration,
    AirportConfiguration,
    AirportConfigurationType,
    ArrivalHallProperties,
    BoardingGateProperties,
    CheckInProperties,
    DepartureHallProperties,
    ParkingProperties,
    Resource,
    ResourceType,
    TerminalProperties,
} from '../../../backend';

const emptyContentByType: Record<
    ResourceType | AirportConfigurationType,
    | ParkingProperties
    | ArrivalHallProperties
    | BoardingGateProperties
    | CheckInProperties
    | DepartureHallProperties
    | TerminalProperties
    | AirlineConfiguration
> = {
    [ResourceType.PARKING]: {
        type: 'ParkingProperties',
        occupationOffset: 0,
        length: 0,
        width: 0,
        codeLetter: '',
        parkingZone: '',
    } as ParkingProperties,

    [ResourceType.TERMINAL]: {
        type: 'TerminalProperties',
        occupationOffset: 0,
        surface: 0,
        passengersBySquareMeter: 0,
    } as TerminalProperties,

    [ResourceType.CHECK_IN]: {
        type: 'CheckInProperties',
        paxCapacity: 1,
        terminal: '',
        zone: '',
        srb: '',
        dcs: [],
    } as CheckInProperties,
    [ResourceType.ARR_HALL]: {
        type: 'ArrivalHallProperties',
        surface: 0,
        passengersBySquareMeter: 0,
        terminal: '',
        offsetSTA: 0,
    } as ArrivalHallProperties,
    [ResourceType.DEP_HALL]: {
        type: 'DepartureHallProperties',
        surface: 0,
        passengersBySquareMeter: 0,
        terminal: '',
        offsetSTD: 0,
    } as DepartureHallProperties,
    [ResourceType.BOARDING_GATE]: {
        type: 'BoardingGateProperties',
        paxCapacity: 1,
        departureHall: '',
    } as BoardingGateProperties,
    [AirportConfigurationType.AIRLINES]: {
        type: 'AirlineConfiguration',
        name: '',
        codeIata: '',
        codeIcao: '',
        gateOpeningOffset: 0,
        gateClosingOffset: 0,
    } as AirlineConfiguration,
};

export const getEmptyObjectByType = (
    valueType: ResourceType | AirportConfigurationType,
    defaultValue?: AirportConfiguration,
) => {
    if (
        Object.values(ResourceType)
            .map(t => t.toString())
            .includes(valueType.toString())
    ) {
        return {
            name: '',
            type: valueType,
            shortName: '',
            active: true,
            capacity: 1,
            minTimeBetweenUse: 0,
            content: emptyContentByType[valueType] || null,
        } as Resource;
    } else if (
        Object.values(AirportConfigurationType)
            .map(t => t.toString())
            .includes(valueType.toString())
    ) {
        const emptyContent = emptyContentByType[valueType];

        if (defaultValue && defaultValue.content?.type === 'AirlineConfiguration') {
            return {
                type: valueType,
                active: true,
                content:
                    emptyContent !== undefined
                        ? {
                              ...emptyContent,
                              gateOpeningOffset: defaultValue.content.gateOpeningOffset,
                              gateClosingOffset: defaultValue.content.gateClosingOffset,
                          }
                        : null,
            } as AirportConfiguration;
        } else {
            return {
                type: valueType,
                active: true,
                content: emptyContent !== undefined ? emptyContent : null,
            } as AirportConfiguration;
        }
    } else {
        return null;
    }
};
